module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/system128.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [(_vm.flag === 'es') ? _c('h1', [_vm._v("¿Usted está perdido?")]) : (_vm.flag === 'de') ? _c('h1', [_vm._v("Bist du verloren?")]) : (_vm.flag === 'us') ? _c('h1', [_vm._v("You are lost?")]) : _c('h1', [_vm._v("Você está perdido?")]), _vm._v(" "), (_vm.flag === 'es') ? _c('h4', [_vm._v("¡Esta página no existe!")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Diese Seite existiert nicht!")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("This page does not exist!")]) : _c('h4', [_vm._v("Essa página não existe!")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [(_vm.flag === 'es') ? _c('span', [_vm._v("Ve a la principal.")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Gehe zum Haupt.")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Ve a la principal.")]) : _c('span', [_vm._v("Ir para a principal.")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e71a53b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 333
// module chunks = 1